import React, { useEffect } from "react";
import { gsap } from "gsap";

interface StepIndicatorProps {
  steps: string[];
  currentStep: number;
  progressPercentage: number;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({
  steps,
  currentStep,
  progressPercentage,
}) => {
  useEffect(() => {
    gsap.fromTo(
      `.step-${currentStep}`,
      { backgroundColor: "#e5e7eb", color: "#1f2937" },
      { backgroundColor: "#1f2937", color: "#ffffff", duration: 0.5 }
    );
  }, [currentStep]);

  useEffect(() => {
    gsap.to(`.progress-${currentStep}`, {
      strokeDashoffset: 100 - progressPercentage,
      duration: 0.5,
    });
  }, [progressPercentage, currentStep]);

  const getGridColsClass = () => {
    switch (steps.length * 2 - 1) {
      case 1:
        return "grid-cols-1";
      case 3:
        return "grid-cols-3";
      case 5:
        return "grid-cols-5";
      case 7:
        return "grid-cols-7";
      case 9:
        return "grid-cols-9";
      default:
        return "";
    }
  };

  const gridColsClass = getGridColsClass();

  return (
    <div className="hidden md:block">
      <div
        className={`grid ${gridColsClass} gap-4 w-full max-w-4xl my-8 items-center`}
      >
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <div className="flex flex-col items-center justify-center col-span-1 relative">
              <svg className="relative w-12 h-12" viewBox="0 0 36 36">
                {/* Outer Circle */}
                <circle
                  className={`progress-${index + 1}`}
                  stroke="#1f2937"
                  strokeWidth="2"
                  fill="none"
                  strokeDasharray="100"
                  strokeDashoffset={index + 1 <= currentStep ? "0" : "100"}
                  cx="18"
                  cy="18"
                  r="16"
                />
                {/* Inner Circle */}
                <circle
                  cx="18"
                  cy="18"
                  r="10"
                  fill={index + 1 <= currentStep ? "#1f2937" : "#e5e7eb"}
                />
                {/* Step Number */}
                <text
                  x="18"
                  y="22"
                  fill={index + 1 <= currentStep ? "#ffffff" : "#1f2937"}
                  fontSize="10"
                  textAnchor="middle"
                  fontWeight="bold"
                >
                  {index + 1}
                </text>
              </svg>
              <span className="text-small mt-2 text-center max-w-xs">
                {step}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div className="flex-grow h-0.5 bg-gray-300 mx-2"></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;
